<template>
  <div
    class="gen-poster"
    v-loading="isUploading"
  >
    <ul
      class="tabs"
      v-if="userId"
    >
      <li
        v-for="tab in tabs"
        :key="tab.id"
        :class="{ active: tab.id === activeTab }"
        @click="activeTab = tab.id"
      >
        {{ tab.name }}
      </li>
    </ul>
    <div v-if="activeTab === 1">
      <buildLong
        :isSpecific="true"
        @onGenerate="onGenerate"
      ></buildLong>
    </div>
    <div v-if="activeTab === 2">
      <posterList
        :userId="userId"
        @toDesignDetail="toDesignDetail"
      ></posterList>
    </div>
  </div>
</template>
<script>
import { onUpload } from './specific-feature';
import buildLong from '@/pages/poster/build-long.vue';
import posterList from '@/pages/poster/poster-list.vue';
import { mapMutations, mapState } from 'vuex';
import {
  savePosterLongToBase,
  getPosterLongDetail,
  getLogos,
  getContentStyles,
  resolvePosterLogos,
} from '@/pages/poster/js/poster-feature';
import { htmlToCanvas } from '@assets/scripts/features';
export default {
  name: 'build',
  data() {
    return {
      tabs: [
        {
          name: '制作海报',
          id: 1,
        },
        { name: '我的设计', id: 2 },
      ],
      activeTab: 1,
      userId: '',
      isUploading: false,
      uploadUrl: 'https://shopcenter.xkw.com/info/shop/premote',
      logoId: 20,
      logoOptions: [],
      contentStyles: [],
    };
  },
  components: {
    buildLong,
    posterList,
  },
  async mounted() {
    const { uploadUrl, userId, id } = this.$route.query;
    if (uploadUrl) {
      this.uploadUrl = uploadUrl;
    }
    this.userId = userId;
    if (id) {
      this.logoId = parseInt(id);
    }
    this.logoOptions = await getLogos();
    const logoInfo = this.logoOptions.find((item) => Number(item.id) === Number(this.logoId));
    this.updatePosterData({
      logos: logoInfo ? [logoInfo] : [],
    });
  },
  computed: {
    ...mapState('posterLong', ['posterData', 'posterTextMaps']),
  },
  methods: {
    ...mapMutations('posterLong', ['updatePosterData', 'updatePosterTextMaps']),
    async onGenerate() {
      this.isUploading = true;
      let dom = document.querySelector('#poster');
      const posterBase64Data = await htmlToCanvas(dom, 2);
      if (this.userId) {
        savePosterLongToBase(
          this.posterData,
          this.posterTextMaps,
          '',
          this.userId
        );
      }
      await onUpload(posterBase64Data, this.uploadUrl);
      this.isUploading = false;
    },
    toDesignDetail(schemeId) {
      this.activeTab = 1;
      this.getDesignDetail(schemeId);
    },
    // 获取用户设计详情
    async getDesignDetail(schemeId) {
      const data = await getPosterLongDetail(schemeId);
      if (!data || !Object.keys(data).length) {
        return;
      }
      data.logos = resolvePosterLogos(data.logos, this.logoOptions);
      if (this.contentStyles.length === 0) {
        this.contentStyles = await getContentStyles();
      }
      data.contentStyle =
        this.contentStyles.find((item) => Number(item.id) === Number(data.contentStyleId)) ||
        this.contentStyles[0];
      const { posterTextMaps, ...posterData } = data;
      this.updatePosterData(posterData);
      if (Array.isArray(posterTextMaps)) {
        this.updatePosterTextMaps(posterTextMaps);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs {
  display: flex;
  justify-content: start;
  align-items: center;
  height: 50px;
  width: 800px;
  margin: 0 calc(50vw - 400px - 150px);
  li {
    cursor: pointer;
    line-height: 50px;
    width: 100px;
    text-align: center;
    color: #999;
    &.active {
      color: #3f69f9;
    }
  }
}
</style>
